import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useTenantContext } from 'shared/contexts';

import { ErrorTypes } from '../api/error';
import { ErrorTranslationKey } from './errors';

const useErrorText = () => {
    const { t } = useTranslation('errors');
    const { tenantName } = useTenantContext();

    return useCallback((key: string, context?: string) => {
        // Use 'general' error as a fallback
        const keys = [ key, ErrorTypes.General ] as ErrorTranslationKey[];

        return t(keys, { tenantName, context });
    }, [ t, tenantName ]);
};

export { useErrorText };
